<template>
  <el-header class="header">
    <div class="header-left">
      <span class="brand-icon"></span>
      <span class="brand-name">青鸾</span>
      <span class="brand-sub">XCPC 效能工具</span>
    </div>
    <div class="header-right">
      <span class="user-name">{{ username }}</span>
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          <el-icon size="20px">
            <Setting />
          </el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="exit">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </el-header>
</template>

<script>
import router from '@/core/router';
import { ref } from 'vue';
import { clearLoginSession } from '@/core/utils/loginSession';

export default {
  name: 'AppHeader',
  setup() {
    const username = ref('');
    function exit() {
      clearLoginSession();
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('isLogin');
      localStorage.removeItem('user');
      localStorage.removeItem('userInfo');
      router.push('/login');
    }
    return { username, exit };
  },
  created() {
    this.username = localStorage.getItem('user') || '用户';
  },
};
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 24px;
  background: var(--accent-dark, #114d58);
  color: #fff;
  position: relative;
  z-index: 10;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-icon {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--accent, #0f7c82);
  box-shadow: 0 0 6px rgba(15, 124, 130, 0.6);
}

.brand-name {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.brand-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-left: 4px;
  font-weight: 400;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-name {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.7);
  transition: color 0.2s;
}

.el-dropdown-link:hover {
  color: #fff;
}

.el-dropdown-link:focus {
  outline: none;
}
</style>
